<template>
  <div class="icon-item">
    <p v-html="title"></p>
    <img :src="iconImage && '/icons/icon-' + iconImage" />
  </div>
</template>

<script>
export default {
  name: 'IconItem',
  props: ['title', 'iconImage'],
};
</script>

<style lang="stylus" scoped>
  @require '../style/colors'

  .icon-item
    width: 20rem
    text-align: center

    p
      display: flex
      justify-content: center
      align-items: flex-end
      height: 5rem
      margin: 0
      font-weight: 300

    img
      height: 15rem
      width: 15rem

</style>
